import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfig } from '../core/services/app-config.service';
import { DemoService } from './demo.service';

@Injectable({
  providedIn: 'root',
})
export class DemoGuard implements CanActivate {
  constructor(private appConfig: AppConfig, private demoService: DemoService) {}

  public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.appConfig.config.demo) {
      this.demoService.openDialog();
      return false;
    }

    return true;
  }
}
